import Vue from 'vue';
import { UserService } from '@/services/UserService';
import { AssociationService } from '@/services/AssociationService';
import { AspNetRole, AssociationRoleEnum } from '../../models/Enums';
import SelectListItem from '../../models/SelectListItem';
import AdminRegistrationRequest from '../../models/api/user/AdminRegistrationRequest';
import UserRegistrationRequest from '../../models/api/user/UserRegistrationRequest';
import DeleteDialog from '@/components/dialogs/DeleteDialog.vue';
import { DataTableHelper } from '@/helpers/DataTableHelper';
import Admin from './Admin.vue';
import User from './User.vue';

export default Vue.extend({
    components: {
        DeleteDialog,
        Admin,
        User
    },
    data() {
        return {
        }
    },
    created() {
    },
    watch: {
    },
    methods: {
    },
});
